import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PikkoLanding from "@/pages/PikkoLanding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PikkoLanding />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
